import React, { useEffect, useState } from 'react';
import CustomSelect from '../../../../components/CustomSelect';

export const RequirementDetails = ({ courses = [], isLoadingCourses = false }) => {
    const [locationMapUrl, setLocationMapUrl] = useState('');
    const [selectedCourse, setSelectedCourse] = useState(null);

    // Today's date in local YYYY-MM-DD format
    const todayDate = (() => {
        const d = new Date();
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    })();

    const courseList = [
        ...courses,
        { value: 'other', label: 'Other' }
    ];

    // Automatically select the first option
    useEffect(() => {
        if (courses && courses.length > 0) {
            setSelectedCourse(courses[0]);
        } else if (courseList.length > 0 && !selectedCourse) {
            setSelectedCourse(courseList[0]);
        }
    }, [courses]);

    const isValidUrl = (url) => {
        try {
            return url && (url.startsWith('http://') || url.startsWith('https://') || url.includes('maps'));
        } catch {
            return false;
        }
    };

    const handleOpenMap = () => {
        if (!locationMapUrl) return;
        const targetUrl = locationMapUrl.startsWith('http') ? locationMapUrl : `https://${locationMapUrl}`;
        window.open(targetUrl, '_blank', 'noopener,noreferrer');
    };

    return (
        <div className="enquiry-section">
            {/* Hidden backend fields */}
            <input type="hidden" name="preffered_batch" value="morning" />
            <input type="hidden" name="tryal_date" value={todayDate} />
            <input type="hidden" name="tryal_period" value={1} />

            <div className="d-flex align-items-center gap-2 mb-2">
                <span className="section-title-badge bg-soft-warning text-warning">
                    <i className="ri-list-check-2 me-1"></i>Requirements & Location
                </span>
            </div>

            <div className="row g-3">
                {/* Client Required / Course */}
                <div className="col-12 col-md-6">
                    <label htmlFor="course" className="form-label form-label-custom">
                        <i className="ri-book-open-line text-muted me-1"></i>
                        Course / Requirement
                    </label>
                    <CustomSelect
                        name="course_id"
                        isSearchable
                        id="course"
                        placeholder={isLoadingCourses ? 'Loading courses...' : 'Select course...'}
                        options={courseList}
                        value={selectedCourse}
                        onChange={(selected) => setSelectedCourse(selected)}
                    />
                </div>

                {/* Follow Up Date */}
                <div className="col-12 col-md-6">
                    <label htmlFor="joining_date" className="form-label form-label-custom">
                        <i className="ri-calendar-event-line text-muted me-1"></i>
                        Follow up Date
                    </label>
                    <input
                        type="date"
                        className="form-control form-control-custom"
                        id="joining_date"
                        name="joining_date"
                        defaultValue={todayDate}
                    />
                </div>

                {/* Location Map */}
                <div className="col-12">
                    <div className="d-flex justify-content-between align-items-center mb-1">
                        <label htmlFor="feedback" className="form-label form-label-custom mb-0">
                            <i className="ri-map-pin-2-fill text-danger me-1"></i>
                            Google Map Location Link
                        </label>
                        {isValidUrl(locationMapUrl) && (
                            <button
                                type="button"
                                onClick={handleOpenMap}
                                className="btn btn-sm btn-soft-primary py-0 px-2 fs-12"
                                title="Open link in new tab"
                            >
                                <i className="ri-external-link-line me-1"></i>Test Location Map
                            </button>
                        )}
                    </div>
                    <div className="input-group">
                        <span className="input-group-text bg-light text-muted">
                            <i className="ri-google-line"></i>
                        </span>
                        <input
                            type="text"
                            className="form-control form-control-custom"
                            id="feedback"
                            name="feedback"
                            value={locationMapUrl}
                            onChange={(e) => setLocationMapUrl(e.target.value)}
                            placeholder="Paste Google Map location link (e.g. https://maps.app.goo.gl/...)"
                        />
                    </div>
                    <small className="text-muted fs-11 mt-1 d-block">
                        <i className="ri-information-line me-1"></i>
                        Paste the school or location's Google Map URL for quick navigation.
                    </small>
                </div>
            </div>
        </div>
    );
};

export default RequirementDetails;
